const NOTIFICATION_MESSAGE = {
  REGIONS_ADDED: "Region added successfully.",
  CLINIC_DOMAIN_ADDED: "Clinic domain added successfully.",
  CLINIC_ADDED: "Clinic added successfully.",
  CLINIC_UDDATED:"Clinic updated successfully",

  ADMINS_ADDED: "Admin user added successfully.",
  ADMINS_UPDATED: "Admin user updated successfully.",

  DELETE_CLIENT: "Client deleted successfully.",
  ERROR_DELETE_CLIENT: "Error while deleting client.",
  CLIENT_CREATED: "Client added successfully.",
  CLIENT_UPDATED: "Client details updated.",
  SITES_ADDED: "Sites added successfully.",
  SIBLING_ADDED: "Sibling added successfully.",
  SIBLING_UPDATED: "Sibling updated successfully.",
  SIBLING_DELETED: "Sibling deleted successfully.",
  USERNAME_SUBMITTED: "Otp has been sent to your registered phone number.",

  PASSWORD_CHANGED: "Password changed successfully",
  OTP_CONFIRMED: "Otp confirmed successfully",

  TREATMENT_PLAN_DELETED: "Treatment plan deleted successfully.",
  TREATMENT_OBJECTIVE_DELETED: "Objective deleted successfully.",
  TREATMENT_INTERVENTION_DELETED: "Intervention deleted successfully.",
  REACTIVATE_CLIENT: "Client reactivated successfully.",

  CLINIC_STATUS : "Status Updated Succesfully",

  CLINIC_CONTACT_ADDED:"Clinic Contact added successfully",
  CLINIC_CONTACT_UPDATED:"Clinic Contact updated successfully",
  //-------------------------- staff notifiation message --------------------------------//
  INACTIVE_STAFF: "Staff Deactivated Successfully",
  ACTIVE_STAFF: "Staff Reactivated Successfully",
  UPDATE_STAFF: "Staff profile updated successfully",
  ADD_STAFF: "Staff added successfully",
  ADD_POSITION: "Position added successfully",
  UPDATE_POSITION: "Update position successfully",
  UPLOAD_PHOTO: "Profile photo successfully uploaded",

  //-------------------------- general notifiation message --------------------------------//
  SUCCESS: "Success",

  TASK_DELETED: "Task deleted successfully.",
  DISCUSSION_DELETED: "Discussion deleted successfully.",
  DISCUSSION_UPDATED: "Discussion updated successfully.",

  SIGNATURE_DELETED: "Signature deleted successfully.",

  //-------------------------- settings message --------------------------------//
  CLINIC_REFERRING_PROVIDER: "Referring provider added successfully.",
  UPDATED_REFERRING_PROVIDER: "Referring provider updated successfully.",

  CLINIC_REF_SOURCE: "Referring source added successfully.",
  UPDATED_REF_SOURCE: "Referring source updated successfully.",

  //-------------------------- training Link--------------------------------//
  TRAINING_LINK_ADDED: "Training Link Added Successfully",
  TRAINING_LINK_UPDATED: "Training Link Updated Successfully.",
};

export default NOTIFICATION_MESSAGE;
